import PillVariant from '~enums/pillVariant';

export enum ConnectivityProfileEnum {
	BatterySave = 1,
	Localizable = 2,
	Responsive = 3,
	Performance = 4,
}

export enum ConnectivityProfileFrequencyEnum {
	Minimal = 'minimal',
	Balanced = 'balanced',
	Frequent = 'frequent',
}

type ConnectivityProfileField = 'batterySave' | 'localizable' | 'responsive' | 'performance';
type ConnectivityProfileFieldKey =
	`connectivityProfile.fields.${ConnectivityProfileField}.${'name' | 'description' | 'estimatedBatteryLife'}`;
type ConnectivityProfileFrequencyKey =
	`connectivityProfile.frequency.${ConnectivityProfileFrequencyEnum}`;

export interface ConnectivityProfileFrequency {
	id: ConnectivityProfileFrequencyEnum;
	title: ConnectivityProfileFrequencyKey;
	variant: PillVariant;
}

export interface ConnectivityProfile {
	id: ConnectivityProfileEnum;
	name: ConnectivityProfileFieldKey;
	description: ConnectivityProfileFieldKey;
	estimatedBatteryLife: ConnectivityProfileFieldKey;
	gpsLocationDetermination: ConnectivityProfileFrequency;
	lteServerCommands: ConnectivityProfileFrequency;
}

const frequencyById: Record<ConnectivityProfileFrequencyEnum, ConnectivityProfileFrequency> = {
	[ConnectivityProfileFrequencyEnum.Minimal]: {
		id: ConnectivityProfileFrequencyEnum.Minimal,
		title: 'connectivityProfile.frequency.minimal',
		variant: PillVariant.Orange,
	},
	[ConnectivityProfileFrequencyEnum.Balanced]: {
		id: ConnectivityProfileFrequencyEnum.Balanced,
		title: 'connectivityProfile.frequency.balanced',
		variant: PillVariant.Yellow,
	},
	[ConnectivityProfileFrequencyEnum.Frequent]: {
		id: ConnectivityProfileFrequencyEnum.Frequent,
		title: 'connectivityProfile.frequency.frequent',
		variant: PillVariant.Green,
	},
};

export const connectivityProfiles: Record<ConnectivityProfileEnum, ConnectivityProfile> = {
	[ConnectivityProfileEnum.BatterySave]: {
		id: ConnectivityProfileEnum.BatterySave,
		name: 'connectivityProfile.fields.batterySave.name',
		description: 'connectivityProfile.fields.batterySave.description',
		estimatedBatteryLife: 'connectivityProfile.fields.batterySave.estimatedBatteryLife',
		gpsLocationDetermination: frequencyById[ConnectivityProfileFrequencyEnum.Minimal],
		lteServerCommands: frequencyById[ConnectivityProfileFrequencyEnum.Minimal],
	},
	[ConnectivityProfileEnum.Localizable]: {
		id: ConnectivityProfileEnum.Localizable,
		name: 'connectivityProfile.fields.localizable.name',
		description: 'connectivityProfile.fields.localizable.description',
		estimatedBatteryLife: 'connectivityProfile.fields.localizable.estimatedBatteryLife',
		gpsLocationDetermination: frequencyById[ConnectivityProfileFrequencyEnum.Frequent],
		lteServerCommands: frequencyById[ConnectivityProfileFrequencyEnum.Balanced],
	},
	[ConnectivityProfileEnum.Responsive]: {
		id: ConnectivityProfileEnum.Responsive,
		name: 'connectivityProfile.fields.responsive.name',
		description: 'connectivityProfile.fields.responsive.description',
		estimatedBatteryLife: 'connectivityProfile.fields.responsive.estimatedBatteryLife',
		gpsLocationDetermination: frequencyById[ConnectivityProfileFrequencyEnum.Minimal],
		lteServerCommands: frequencyById[ConnectivityProfileFrequencyEnum.Frequent],
	},
	[ConnectivityProfileEnum.Performance]: {
		id: ConnectivityProfileEnum.Performance,
		name: 'connectivityProfile.fields.performance.name',
		description: 'connectivityProfile.fields.performance.description',
		estimatedBatteryLife: 'connectivityProfile.fields.performance.estimatedBatteryLife',
		gpsLocationDetermination: frequencyById[ConnectivityProfileFrequencyEnum.Frequent],
		lteServerCommands: frequencyById[ConnectivityProfileFrequencyEnum.Frequent],
	},
};

export const getConnectivityProfile = (id?: number): ConnectivityProfile | undefined =>
	connectivityProfiles[id as ConnectivityProfileEnum];

export default ConnectivityProfile;
